import dialog from '@/components/dialog/dialog';
const plugins = {};
plugins.install = Vue => {
    Vue.mixin({
        components: {
            iDialog: dialog,
        },
    });
};
export default plugins;